import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';
import { X, MessageCircle } from 'lucide-react';

const WHATSAPP_URL = 'https://wa.me/919663112394?text=Hi!%20I%27m%20interested%20in%20getting%20a%20website%20for%20my%20business';

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[100]" data-testid="whatsapp-float-container">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 10 }}
            className="absolute bottom-full right-0 mb-3 w-64 bg-white rounded-2xl shadow-2xl border border-neutral-100 p-4"
            data-testid="whatsapp-tooltip"
          >
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-neutral-400 hover:text-neutral-600"
              aria-label="Close tooltip"
            >
              <X className="w-4 h-4" />
            </button>
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 bg-[#25D366] rounded-full flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="font-heading font-bold text-neutral-800 text-sm">Need a website?</p>
                <p className="text-neutral-500 text-xs mt-1">Chat with us on WhatsApp. We reply instantly!</p>
              </div>
            </div>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 block text-center py-2 bg-[#25D366] text-white rounded-lg font-medium text-sm hover:bg-[#20bd5a] transition-colors"
              data-testid="whatsapp-tooltip-cta"
            >
              Start Chat
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setShowTooltip(!showTooltip)}
        className="whatsapp-float"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        data-testid="whatsapp-float-button"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="w-7 h-7" />
      </motion.button>
    </div>
  );
};

export default WhatsAppButton;
